var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Home"},[_c('promotional-slider',{attrs:{"slides":_vm.formatedSlides}}),_c('news-letter-invitation'),_c('networks-banner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }